import styled from 'styled-components';
import { shimmer } from 'styles/animations';

interface SkeletonProps {
  width?: string;
  height?: string;
  borderRadius?: string;
}

export const Skeleton = styled.div<SkeletonProps>`
  ${shimmer}
  display: block;
  width: ${p => p.width || '100%'};
  height: ${p => p.height || '1.6rem'};
  border-radius: ${p => p.borderRadius || '4px'};
`;
